// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/period_schedule_creation_mode.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schedules/v1/resources/period_schedule_creation_mode.proto.
 */
export const file_studyo_today_schedules_v1_resources_period_schedule_creation_mode = /*@__PURE__*/
  fileDesc("CkdzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9wZXJpb2Rfc2NoZWR1bGVfY3JlYXRpb25fbW9kZS5wcm90bxIjc3R1ZHlvLnRvZGF5LnNjaGVkdWxlcy52MS5yZXNvdXJjZXMq2QEKGlBlcmlvZFNjaGVkdWxlQ3JlYXRpb25Nb2RlEi0KKVBFUklPRF9TQ0hFRFVMRV9DUkVBVElPTl9NT0RFX1VOU1BFQ0lGSUVEEAASKAokUEVSSU9EX1NDSEVEVUxFX0NSRUFUSU9OX01PREVfU0lOR0xFEAESMQotUEVSSU9EX1NDSEVEVUxFX0NSRUFUSU9OX01PREVfUEVSX0RBWV9PRl9XRUVLEAISLworUEVSSU9EX1NDSEVEVUxFX0NSRUFUSU9OX01PREVfUEVSX0NZQ0xFX0RBWRADQiuqAihTdHVkeW8uVG9kYXkuU2NoZWR1bGVzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.schedules.v1.resources.PeriodScheduleCreationMode.
 */
export const PeriodScheduleCreationModeSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_schedules_v1_resources_period_schedule_creation_mode, 0);

/**
 * The possible ways to create period schedules within a new schedule cycle.
 *
 * @generated from enum studyo.today.schedules.v1.resources.PeriodScheduleCreationMode
 */
export const PeriodScheduleCreationMode = /*@__PURE__*/
  tsEnum(PeriodScheduleCreationModeSchema);

